import { render, staticRenderFns } from "./ViewDeathRecords.vue?vue&type=template&id=1404c7c2&"
import script from "./ViewDeathRecords.vue?vue&type=script&lang=js&"
export * from "./ViewDeathRecords.vue?vue&type=script&lang=js&"
import style0 from "./ViewDeathRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports